import { lazy, Suspense, useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'

import { RenderIf } from 'utils'
// import { getVerificationAction } from 'store/sagaActions'

const AlertModal = lazy(() => import('components/modal/alertModal/AlertModal'))

const HeaderTabCard = ({
	key = '',
	linkTo = '',
	linkName = '',
	linkImage = '',
	isActive = false,
}) => {
	const { pathname } = useLocation()
	// const dispatch = useDispatch()

	// const { userData } = useSelector((state) => state?.user?.userDetails)
	const { isKYCVerified, isEmailVerified } = useSelector((state) => state.user.verification)

	const [show, setShow] = useState(false)
	const [showEmailModal, setshowEmailModal] = useState(false)
	const [kycVerification, setKycVerification] = useState(false)
	const [redirectionTo, setRedirectionTo] = useState('')

	const closeModal = () => {
		setShow(false)
	}

	const closeEmailModal = () => {
		setshowEmailModal(false)
	}
	const handleLinkClick = () => {
		if (linkName === 'Dashboard') {
			setShow(false)
			return
		}

		if (isKYCVerified) {
			if (isEmailVerified) {
				setshowEmailModal(false)
				return
			}
			setShow(false)

			setshowEmailModal(true)
			return
		}

		setShow(true)
		// setshowEmailModal(true);
	}

	const handleKYCAlert = () => {
		if (isKYCVerified) {
			setKycVerification(true)
		} else {
			setKycVerification(false)
		}
	}

	useEffect(() => {
		if (
			linkName === 'Dashboard' ||
			linkName === 'Identity Verification' ||
			linkName === 'Settings' ||
			linkName === 'Accounts'
		) {
			setRedirectionTo(linkTo)
		} else if (pathname === '/dashboard') {
			setRedirectionTo('/dashboard')
		} else {
			setRedirectionTo(pathname)
		}
	}, [linkName, pathname])

	useEffect(() => {
		// dispatch(getVerificationAction())
		handleKYCAlert()
	}, [isKYCVerified])

	return (
		<>
			<Link
				key={key}
				to={!kycVerification ? redirectionTo : linkTo}
				className={`align-items-center custom_dashboard_tabs ${
					isActive ? 'active_tab' : 'inactive_tab '
				}${linkName == 'Help' ? 'help' : ''}`}
				onClick={handleLinkClick}
			>
				{linkImage && <img src={linkImage} alt="dashboard_icon" />}
				<p>{linkName}</p>
			</Link>
			<RenderIf isTrue={show}>
				<Suspense fallback={null}>
					<AlertModal showModal={show} closeModal={closeModal} kycModal={true} />
				</Suspense>
			</RenderIf>
			<RenderIf isTrue={showEmailModal}>
				<Suspense fallback={null}>
					<AlertModal
						showModal={showEmailModal}
						closeModal={closeEmailModal}
						kycModal={false}
					/>
				</Suspense>
			</RenderIf>
		</>
	)
}

export default HeaderTabCard
